import { render, staticRenderFns } from "./treatments-filter.vue?vue&type=template&id=f694297c"
import script from "./treatments-filter.vue?vue&type=script&lang=ts"
export * from "./treatments-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports